import { motion } from "framer-motion";
import { Crosshair, Sparkles, UserCheck, Building2, Heart, Zap } from "lucide-react";

const reasons = [
  {
    icon: Crosshair,
    title: "Focused Expertise",
    description: "Expertise focused only on women's cancers",
  },
  {
    icon: Sparkles,
    title: "Advanced Techniques",
    description: "Advanced surgical techniques for better outcomes",
  },
  {
    icon: UserCheck,
    title: "Personalized Care",
    description: "Personalized treatment plans for every patient",
  },
  {
    icon: Building2,
    title: "Multidisciplinary Approach",
    description: "Multidisciplinary approach with leading hospitals",
  },
  {
    icon: Heart,
    title: "Compassionate Support",
    description: "Compassionate care throughout diagnosis and recovery",
  },
  {
    icon: Zap,
    title: "Faster Recovery",
    description: "Focus on minimally invasive and faster recovery procedures",
  },
];

export default function WhyChooseSection() {
  return (
    <section
      id="why-choose"
      data-testid="why-choose-section"
      className="py-24 md:py-32 bg-[#F9F9F6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left: Sticky heading */}
          <div className="lg:col-span-5 lg:sticky lg:top-28 lg:self-start">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6 }}
            >
              <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[#8FA998] mb-4">
                Why Choose Us
              </p>
              <h2
                data-testid="why-choose-heading"
                className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#1E3F33] leading-tight"
              >
                Why Choose a <span className="text-[#8FA998]">Specialist</span> Gynecologic Oncologist?
              </h2>
            </motion.div>
          </div>

          {/* Right: Numbered list */}
          <div className="lg:col-span-7 space-y-0">
            {reasons.map((reason, i) => (
              <motion.div
                key={reason.title}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`why-choose-item-${i}`}
                className="flex items-start gap-5 py-7 border-b border-[#D8DDD9] last:border-0 group"
              >
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-[#1E3F33]/10 flex items-center justify-center">
                  <reason.icon className="w-5 h-5 text-[#1E3F33]" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg sm:text-xl font-semibold text-[#1E3F33] leading-snug mb-1">
                    {reason.title}
                  </h3>
                  <p className="text-[#4A6359] text-sm sm:text-base leading-relaxed">
                    {reason.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
